export default __webpack_public_path__ + "static/media/errorImg.a996f4ea.png";